import React from 'react';
import { TrainingOverviewTab } from './components/TrainingOverviewTab';
import { TrainingCategoryIconMap } from '../../../../constants/training-category-icon-map';
import { DifficultyIconMap } from '../../../../constants/difficulty-icon-map';
import { TrainingTimeIcon } from '../../../../wag-react/next-components/icons';
import { Flex, FlexProps } from '../../../../wag-react/next-components/Flex';
import { theme } from '../../../../wag-react/themes/base-theme';
export type TrainingOverviewProps = {
  difficulty: string;
  duration: string;
  category: string;
} & FlexProps;
export const TrainingOverview = ({
  difficulty,
  duration,
  category,
  ...rest
}: TrainingOverviewProps) => {
  const DifficultyIcon = DifficultyIconMap[difficulty];
  const CategoryIcon = TrainingCategoryIconMap[category];
  const tabs = [{
    Icon: DifficultyIcon,
    text: difficulty
  }, {
    Icon: TrainingTimeIcon,
    text: duration
  }, {
    Icon: CategoryIcon,
    text: category
  }];
  return <Flex bg={theme.colors.backgroundGray} borderRadius={[0, null, '8px']} height="40px" width={1} {...rest} data-sentry-element="Flex" data-sentry-component="TrainingOverview" data-sentry-source-file="index.tsx">
      {tabs.map(({
      Icon,
      text
    }) => <>
          {Icon && <TrainingOverviewTab key={text} Icon={Icon} text={text} />}
        </>)}
    </Flex>;
};